<template>
  <select :value="value"  autocomplete="off" @change="emitInput" class="basic-select" :disabled="disable">
    <option v-if="renderBlankOptions" value="" :aria-selected="renderBlankOptions.selected">
      {{ renderBlankOptions.external }}
    </option>
    <option
        v-for="option in renderedOptions"
        :key="option.external"
        :value="option.internal"
        :aria-selected="option.selected"
    >
        {{ option.external }}
    </option>
  </select>
</template>

<script>
// Select from a small set of known values with a regular select box
export default {
  props: {
    value: {
      //set multiple value type to support Slot's permission options to be a Number, while others are String
      type: [Number, String],
      default: '',
    },
    disable: {
        type: Boolean,
        default: null,
    },
    // Object with an array of 'choices' - a choice is an object with an internal and external representation
    // of the choice and a default selection
    options: {
      type: Object,
      required: true,
    },
    // The text that should be displayed for a blank option
    blankText: {
      type: String,
      default: "----------------"
    },
  },
  computed: {
      selected: function() {
          return this.value
      },
    // Whether or not to render a blank option
    renderBlankOptions: function() {
      // If there is no default, we want to render a blank option
      if (this.options.default === null) {
        let blankOption = {}
        blankOption.external = this.blankText
        if (!this.value || this.value.toString() === "") {
            blankOption.selected = true
        } else {
            blankOption.selected = false
        }
        return blankOption
      }
      return null
    },
    renderedOptions: function() {
        let renderedOptions = new Array()
        if (this.options.choices) {
            this.options.choices.forEach(option => {
                if (this.value) {
                    option.internal.toString() === this.value.toString() ? option.selected = true : option.selected = false
                    renderedOptions.push(option)
                } else {
                    option.internal === this.options.default ? option.selected = true : option.selected = false
                    renderedOptions.push(option)
                }
            })
        }
        return renderedOptions
    },
  },
  methods: {
    emitInput: function (event) {
        if (event.target.value === "") {
            this.$emit('input', null)
        }
        this.$emit('input', event.target.value)
    },
  }
}
</script>
<style>
    .basic-select {
        min-width: 50%;
    }
</style>
